/**
 * @file SkeletonHorizontalTitleCard.tsx
 * @description Loading skeleton for HorizontalTitleCard
 *
 * Matches the exact structure and dimensions of HorizontalTitleCard
 * to prevent layout shifts during loading.
 */

import type { ReactElement } from "react";
export function SkeletonHorizontalTitleCard(): ReactElement {
  return (
    <div className="flex-shrink-0 self-start text-left w-[calc(100vw-3rem)] sm:w-[500px] space-y-3 snap-center">
      {/* Landscape image skeleton */}
      <div className="aspect-video bg-neutral-900 rounded-xl animate-pulse" />

      {/* Metadata skeleton */}
      <div className="px-1 space-y-2">
        <div className="flex-1 space-y-2">
          <div className="h-5 bg-neutral-800 rounded w-3/4 animate-pulse" />
          <div className="space-y-1">
            <div className="h-4 bg-neutral-800 rounded w-1/2 animate-pulse" />
            <div className="h-4 bg-neutral-800 rounded w-1/2 animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
